<div [class]="'d-flex flex-column ' + (isDesabilitado ? 'disabled' : '')">
	<label
		for="date-range-{{ controlStartName }}"
		*ngIf="label"
		class="form-label text-tertiary-light"
		>{{ label }}</label
	>
	<mat-form-field id="date-range-{{ controlStartName }}">
		<mat-date-range-input [rangePicker]="picker" [max]="dataMaxima">
			<input
				matStartDate
				[formControlName]="controlStartName"
				[placeholder]="startPlaceholder"
				[attr.disabled]="isDesabilitado ? true : null" />
			<input
				matEndDate
				[formControlName]="controlEndName"
				[placeholder]="endPlaceholder"
				[attr.disabled]="isDesabilitado ? true : null" />
		</mat-date-range-input>
		<mat-datepicker-toggle
			[disabled]="isDesabilitado"
			matIconSuffix
			[for]="picker"></mat-datepicker-toggle>
		<mat-date-range-picker #picker></mat-date-range-picker>
	</mat-form-field>
</div>
